import { useState, useEffect, useRef } from "react";
import TryAgainLogo from "../../assets/images/try-again.png";
import { useLanguage } from "../../contexts/LanguageContext";

const AD_COUNTDOWN_SECONDS = 5;

const GameOverlay = ({ onRestart, board, onKeepGoing, keepPlaying, onContinueAfterAd, hasUsedContinue }) => {
  const { t } = useLanguage();
  const [adStage, setAdStage] = useState("idle");
  const [secondsLeft, setSecondsLeft] = useState(AD_COUNTDOWN_SECONDS);
  const adContainerRef = useRef(null);
  const adPushedRef = useRef(false);

  // 보드가 초기화되거나 게임오버 상태가 풀리면 광고 흐름 상태 리셋
  useEffect(() => {
    if (!board.hasLost()) {
      setAdStage("idle");
      setSecondsLeft(AD_COUNTDOWN_SECONDS);
      adPushedRef.current = false;
    }
  }, [board]);

  // 카운트다운: adStage가 "watching"일 때 1초마다 감소
  useEffect(() => {
    if (adStage !== "watching") return;
    if (secondsLeft <= 0) {
      setAdStage("ready");
      return;
    }
    const id = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(id);
  }, [adStage, secondsLeft]);

  // 광고 표시 시 AdSense 슬롯 1회 push
  useEffect(() => {
    if (adStage !== "watching") return;
    if (adPushedRef.current) return;
    if (!adContainerRef.current) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      adPushedRef.current = true;
    } catch (e) {
      // adsbygoogle 미로드 등의 환경(개발/오프라인)에서는 무시
    }
  }, [adStage]);

  if (board.hasWon() && !keepPlaying) {
    return (
      <div className="game-won overlay">
        <h2>{t('games.2048.victory')}</h2>
        <p>{t('games.2048.continueMessage')}</p>
        <div className="overlay-buttons">
          <button onClick={onRestart} className="try-again-button">
            {t('playAgain')}
          </button>
          <button
            onClick={() => {
              onKeepGoing();
              document.querySelector('.game-won').style.display = 'none';
            }}
            className="keep-going-button"
          >
            {t('games.2048.keepGoing')}
          </button>
        </div>
      </div>
    );
  } else if (board.hasLost()) {
    if (adStage === "idle") {
      return (
        <div className="gameOver-modal overlay">
          <img
            src={TryAgainLogo}
            alt="Game Over"
            className="gameOver-modal-logo"
          />
          <div className="overlay-buttons">
            {!hasUsedContinue && (
              <button
                onClick={() => {
                  setSecondsLeft(AD_COUNTDOWN_SECONDS);
                  setAdStage("watching");
                }}
                className="watch-ad-button"
              >
                {t('games.2048.watchAdContinue')}
              </button>
            )}
            <button onClick={onRestart} className="try-again-button">
              {t('playAgain')}
            </button>
          </div>
        </div>
      );
    }

    // adStage === "watching" 또는 "ready"
    return (
      <div className="gameOver-modal overlay ad-watching">
        <p className="ad-status-text">
          {adStage === "watching"
            ? t('games.2048.adInProgress').replace('%seconds%', String(secondsLeft))
            : t('games.2048.adReady')}
        </p>
        <div className="ad-slot" ref={adContainerRef}>
          <ins
            className="adsbygoogle"
            style={{ display: 'block', width: '100%', minHeight: '120px' }}
                 data-ad-client="ca-pub-3831596389663189"
                 data-ad-slot="5527382780"
                 data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>
        <div className="overlay-buttons">
          <button
            onClick={onContinueAfterAd}
            className="continue-button"
            disabled={adStage !== "ready"}
          >
            {t('games.2048.continueGame')}
          </button>
          <button onClick={onRestart} className="try-again-button">
            {t('playAgain')}
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default GameOverlay;
